/*
 * shipping-status.js
 *
 * App-independent storefront hinting. Shopify checkout remains the
 * source of truth for actual shipping rates.
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.ShippingStatus = factory();
  }
}(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  function classifyLine() {
    return 'S';
  }

  function classifyCart(input) {
    var country = (input.country || '').toUpperCase() || null;
    var thresholdMap = input.thresholdMap || {};
    var cartTotalCents = Number(input.cartTotalCents) || 0;
    var showShippingNotice = input.showShippingNotice !== false;
    var thresholdCents = country ? Math.max(0, Math.floor(Number(thresholdMap[country]) || 0)) : 0;
    var lines = input.lines || [];

    if (lines.length === 0) {
      return {
        outcome: 'empty',
        country: country || '',
        thresholdCents: thresholdCents,
        remainingCents: 0,
        progressVisible: false,
        progressPercent: 0,
        classes: [],
      };
    }

    var remainingCents = 0;
    var progressPercent = 0;
    if (thresholdCents > 0) {
      if (cartTotalCents >= thresholdCents) {
        progressPercent = 100;
      } else {
        remainingCents = thresholdCents - cartTotalCents;
        progressPercent = Math.min(100, Math.floor((cartTotalCents * 100) / thresholdCents));
      }
    }

    return {
      outcome: 'threshold',
      country: country || '',
      thresholdCents: thresholdCents,
      remainingCents: remainingCents,
      progressVisible: showShippingNotice && thresholdCents > 0 && remainingCents > 0,
      progressPercent: progressPercent,
      classes: lines.map(classifyLine),
    };
  }

  function classifyVariantSet(input) {
    var country = (input.country || '').toUpperCase() || null;
    var thresholdMap = input.thresholdMap || {};
    var thresholdCents = country ? Math.max(0, Math.floor(Number(thresholdMap[country]) || 0)) : 0;
    var out = {};
    var variants = input.variants || [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var outcome = 'standard';
      var remaining = 0;
      if (thresholdCents > 0) {
        if (Number(v.price) >= thresholdCents) {
          outcome = 'free';
        } else {
          outcome = 'threshold';
          remaining = thresholdCents - Number(v.price);
        }
      }
      out[String(v.id)] = { outcome: outcome, class: 'S', remaining: remaining };
    }
    return out;
  }

  function normalizeCountryList(raw) {
    if (raw == null) return [];
    if (Array.isArray(raw)) return raw.map(function (x) { return String(x).trim().toUpperCase(); }).filter(Boolean);
    if (typeof raw === 'string' && raw.trim() !== '') return raw.split(',').map(function (x) { return x.trim().toUpperCase(); }).filter(Boolean);
    return [];
  }

  return {
    classifyCart: classifyCart,
    classifyLine: classifyLine,
    classifyVariantSet: classifyVariantSet,
    normalizeCountryList: normalizeCountryList,
  };
}));
